import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../../utils";
/**
 * Single-line cell text that truncates overflow and exposes the full string on
 * hover via the native `title` attribute. Caller supplies a max-width via
 * `className` (e.g. `max-w-[260px]`); without one the text fills its container.
 */ export function TruncatedText({ text, className, fallback = "-" }) {
    if (!text) return fallback;
    return /*#__PURE__*/ _jsx("span", {
        className: cn("block truncate", className),
        title: text,
        children: text
    });
}

//# sourceMappingURL=TruncatedText.js.map